module.exports = __webpack_public_path__ + "img/cost.155b8ee3.svg";